import { render, staticRenderFns } from "./cTabbar.vue?vue&type=template&id=7d783bf3&scoped=true&lang=pug"
import script from "./cTabbar.vue?vue&type=script&lang=js"
export * from "./cTabbar.vue?vue&type=script&lang=js"
import style0 from "./cTabbar.vue?vue&type=style&index=0&id=7d783bf3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d783bf3",
  null
  
)

export default component.exports